import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, FileText } from "lucide-react";
import { inr, monthLabel, downloadFile } from "@/lib/hr";

export default function PayslipsTab() {
  const [slips, setSlips] = useState(null);
  useEffect(() => { api.get("/hr/payslips").then((r) => setSlips(r.data)); }, []);
  if (!slips) return <p className="text-sm text-slate-400">Loading…</p>;
  return (
    <div className="space-y-2.5" data-testid="payslips-tab">
      {slips.map((s) => (
        <div key={s.id} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3 flex-wrap" data-testid={`payslip-row-${s.id}`}>
          <span className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0"><FileText className="w-5 h-5" /></span>
          <div className="flex-1 min-w-[160px]">
            <p className="text-sm font-semibold text-slate-900">{monthLabel(s.month)}</p>
            <p className="text-xs text-slate-500">Gross {inr(s.gross)} · Deductions {inr(s.total_deductions)} · Paid days {s.paid_days}/{s.days_in_month}</p>
          </div>
          <p className="font-display text-lg font-bold text-slate-900" data-testid={`payslip-net-${s.id}`}>{inr(s.net)}</p>
          <Button size="sm" variant="outline" onClick={() => downloadFile(`/hr/payslips/${s.id}/pdf`, `Payslip-${s.month}.pdf`)} data-testid={`payslip-download-${s.id}`}>
            <Download className="w-3.5 h-3.5 mr-1.5" />PDF
          </Button>
        </div>
      ))}
      {!slips.length && <p className="text-sm text-slate-400 py-10 text-center" data-testid="payslips-empty">No payslips yet. They'll appear here once HR runs payroll.</p>}
    </div>
  );
}
